// 容量按新玩法的尖刺负载定（Backlog T053）：投放总量在 validate:content 里对 MAX_SLIMES 校验，
// 落地的史莱姆不消失，玩家什么都不做时总量就是最坏情况；水滴按每步一滴、行程约 1 秒算峰值 71，
// 容量不应限制射速这个手感参数；粒子只决定「多大的连锁开始掉粒子」，满了丢弃不抛错。
export const MAX_SLIMES = 512;
export const MAX_DROPS = 256;
export const MAX_PARTICLES = 2048;
export const MAX_EVENTS = 1024;
export const MAX_COMMANDS = 1024;
export const GRID_CELL_SIZE = 48;
/** 每步接触对的上限。圆盘密排每个至多 6 个邻居，对数 ≤ 3N；瞬时可略超，超出即丢弃并计数。 */
export const MAX_CONTACT_PAIRS = MAX_SLIMES * 4;
/** 黏连绑定表容量与每只的最大绑定数。密排下每只至多 6 条，取 8 留瞬时余量。 */
export const MAX_BONDS_PER_SLIME = 8;
export const MAX_BONDS = (MAX_SLIMES * MAX_BONDS_PER_SLIME) / 2;

// 以下为此前散落在各 System 中的玩法常量，收拢在此并由测试保护（Backlog T042）。
// 半径改为动态后，原先写死的邻域查询半径 44 已由 SlimeStore.maxActiveRadius 取代。
// T045 与 T048 会把其中与压力、投放相关的项迁移到 world.json 的 Setting 层。
// 喷射角抖动与贴墙接触深度已在 T054 迁入 world.json（面板只能调 content 里的字段）；
// 留在这里的 *_SCALE 是原型折算系数，各自已有配对的内容参数。

/** 分离判定的允许重叠：minDistance = r1 + r2 - 此值。留一点重叠让接触看起来是软体。 */
export const SLIME_SEPARATION_SLACK = 2;
/** 位置修正比例。两侧各推 overlap × 此值，合计略小于 1 以避免抖动。 */
export const SLIME_SEPARATION_CORRECTION = 0.48;
/** 分离冲量系数，按 overlap × 此值 × dt 施加。 */
export const SLIME_SEPARATION_IMPULSE = 12;
/** 水滴冲力的整体缩放。取自原型 index.html 的同名系数，与 waterImpulse 相乘后施加。 */
export const WATER_IMPULSE_SCALE = 4.2;

/** 水滴基础图形的绘制半径。运行时按内容定义的半径与速度拉伸缩放。 */
export const DROP_SPRITE_RADIUS = 5;

/** 水滴命中的形变增量与上限。原型是每滴 +0.06 缓慢累积，不是每滴一次满幅压扁。 */
export const SPLAT_SQUASH_STEP = 0.06;
export const SPLAT_MAX_SQUASH = 1.35;

/** 溅射推力的整体缩放。取自原型 index.html 的同名系数。 */
export const SPLASH_PUSH_SCALE = 0.016;

/** 水滴邻域查询的固定余量与行程系数。 */
export const DROP_QUERY_PADDING = 24;
export const DROP_TRAVEL_FACTOR = 0.5;
/** 粒子重力，仅表现层使用，不参与玩法裁决。 */
export const PARTICLE_GRAVITY = 430;
export const FIXED_STEP = 1 / 60;
export const MAX_FRAME_DELTA = 1 / 15;

/**
 * 占位配色（T015 定美术方向前）：深蓝实验室底色。**键集合是回放展示契约的一部分**
 * （replayAssets 把它写进展示清单，`presentationSchema` 只接受这五个键），加色要另开常量。
 */
export const PALETTE = {
  ink: 0x070b1f,
  navy: 0x111a44,
  cream: 0xfff8dc,
  juice: 0xffe978,
  violet: 0x9b7bff,
} as const;

/** 水与水枪共用的一组青蓝，只在游戏渲染器里用，不进回放清单。 */
export const WATER_PALETTE = {
  water: 0x5ad7ff,
  deep: 0x2f7fe6,
  foam: 0xdff8ff,
} as const;
